import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { TagInputModule } from 'ngx-chips';
import { LayoutModule } from '../../../layouts/layout.module';

import { UnitRoutingModule } from './units-routing.module';
import { UnitListComponent } from './unit-list/unit-list.component';
import { UnitNewComponent } from './unit-new/unit-new.component';
import { UnitDetailComponent } from './unit-detail/unit-detail.component';
import { UnitEditComponent } from './unit-edit/unit-edit.component';
import { ApiModule } from '../../../../_services/api.module';
import { GalleryModalModule } from './../../../../shared/gallery-modal';
import { DropPicsGalleryModule } from '../../../../shared/drop-pics-gallery';
import { ActionButtonModule } from '../../../../shared/action-button';
import { DatePickerModule } from '../../../../shared/date-picker';
import { LiveSearchSelectModule } from './../../../../shared/live-search-select';
import { WidgetModule } from './../../../../shared/widget';
import { FilterModule } from './../../../../shared/filter';
import { ContainerModule } from './../../../../shared/container';
import { ListContainerModule } from './../../../../shared/list-container';
import { TabsModule } from './../../../../shared/tabs';
import { DropImageListModalModule } from './../../../../shared/drop-image-list-modal';
import { UnitTableModule } from './unit-table';
import { AgreementModule } from './agreement';
import { ContractComponent } from './contract';
import { InsuranceComponent } from './insurance';
import {
    UnitProviders, InvestorProviders, PropertyProviders, TypeUnitProviders
} from '../../../../_models';

import { TableModule } from '../../../../shared/table';

@NgModule({
    imports: [
        CommonModule,
        UnitRoutingModule,
        LayoutModule,
        BlockUIModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        SweetAlert2Module.forRoot(),
        ApiModule,
        TagInputModule,
        GalleryModalModule,
        DropPicsGalleryModule,
        ActionButtonModule,
        DatePickerModule,
        LiveSearchSelectModule,
        WidgetModule,
        FilterModule,
        ContainerModule,
        ListContainerModule,
        TabsModule,
        UnitTableModule,
        AgreementModule,
        TableModule,
        DropImageListModalModule
    ],
    declarations: [
        UnitListComponent,
        UnitNewComponent,
        UnitDetailComponent,
        UnitEditComponent,
        ContractComponent,
        InsuranceComponent
    ],
    providers: [
        UnitProviders, InvestorProviders, PropertyProviders, TypeUnitProviders]
})
export class UnitsModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/units.module.ts